import request from '../request';


export let addNps = (data) => {
    return request({
        url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.ADMIN) + `/admin/v1/nps`,
        method: 'post',
        data: data
    })
}

export let showNps = (data) => {
    return request({
        url: (process.env.NODE_ENV == 'development' ? '/adminapi' : process.env.ADMIN) + `/admin/v1/nps/fill/` + data.id+'/'+data.channel,
        method: 'get'
    })
}

// 获取用户 identity
export const getUserIdentity = (token) => {
    return request({
      url: `/v3/cv_accounts/${token}/special_offers`,
      method: 'get'
    })
}
  